import { Alley } from '../../../../services/entities/impl/blfApi/schemas/alley';
import { Upload } from '../../../../services/entities/impl/blfApi/schemas/upload';
import { ValidationResult } from '../../utils/validation/validateSchema';

/**
 * Extra validation checks beyond yup validation for Upload objects.
 *
 * @param upload - The upload to validate.
 * @param alleys - The list of alleys to validate against.
 * @returns A ValidationResult object indicating whether the validation passed and any messages.
 */
export const validateUpload = (
  upload: Upload,
  alleys: Alley[]
): ValidationResult => {
  const result: ValidationResult = { valid: true, messages: [] };

  // Check 1: Verify if there's a matching alley with the same filename.  Skip if the file is a collection.json
  if (upload.type !== 'collection.json') {
    const matchingAlley = alleys.find((a) => a.fileName === upload.fileName);
    if (!matchingAlley) {
      result.valid = false;
      result.messages.push({
        path: 'fileName',
        message:
          'No matching alley found for this upload. This may be an unexpected file.',
        severity: 'warning',
      });
    }
  }

  // Check 2: Check for "orig" in the filename which may indicate bag file issues
  if (upload.fileName.toLowerCase().includes('orig')) {
    result.valid = false;
    result.messages.push({
      path: 'fileName',
      message:
        'Filename contains "orig" which may indicate a bag not closing properly.',
      severity: 'warning',
    });
  }

  // Check 3: Verify type and filename match (no bag/collection mismatches)
  const lowerFilename = upload.fileName.toLowerCase();
  if (upload.type === 'bag' && lowerFilename.includes('collection')) {
    result.valid = false;
    result.messages.push({
      path: 'type',
      message:
        'Type and filename mismatch: Upload type is "bag" but filename contains "collection".',
      severity: 'error',
    });
  } else if (
    upload.type === 'collection.json' &&
    lowerFilename.includes('bag')
  ) {
    result.valid = false;
    result.messages.push({
      path: 'type',
      message:
        'Type and filename mismatch: Upload type is "collection.json" but filename contains "bag".',
      severity: 'error',
    });
  }

  return result;
};
